import React, { Component } from "react";

class TableheadRefree extends Component {
  render() {
    const {
      type,
      headOne,

      headTwo,
      headThree,
      headFour,
      headFive,
      headSix,
      headSeven,
      headEight,
    } = this.props;
    return (
      <React.Fragment>
        <tr>
          <th style={{ width: "10%" }}>{headOne}</th>
          <th style={{ width: type === 1 ? "10%" : "20%" }}>{headTwo}</th>
          <th style={{ width: "15%" }}>{headThree}</th>
          <th style={{ width: type === 1 ? "10%" : "15%" }}>{headFour}</th>
          <th style={{ width: type === 1 ? "15%" : "10%" }}>{headFive}</th>
          <th style={{ width: "10%" }}>{headSix}</th>
          <th style={{ width: !headEight ? "20%" : "10%" }}>{headSeven}</th>
          {headEight && <th style={{ width: "20%" }}>{headEight}</th>}
        </tr>
      </React.Fragment>
    );
  }
}

export default TableheadRefree;
